import { render } from "./FormInscricaoEstruture.vue?vue&type=template&id=2f6c5950&scoped=true"
import script from "./FormInscricaoEstruture.vue?vue&type=script&lang=js"
export * from "./FormInscricaoEstruture.vue?vue&type=script&lang=js"

import "./FormInscricaoEstruture.vue?vue&type=style&index=0&id=2f6c5950&scoped=true&lang=css"

import exportComponent from "/Users/rhylton/Sites/projeto-obras/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6c5950"]])

export default __exports__